import React from 'react';
import { useNavigate } from 'react-router-dom';
import { KEY_DATAPROVIDEAGREESEQ } from 'tools/WebTool';
import { SectionWrapper } from './style';
import ROUTE_PATH from 'routes/config';
import { LINKAGE_STATUS_NAME } from '../constants';

const NoticeSection = ({ essentialMallData }) => {
  const navigate = useNavigate();
  const {
    essentialMallList = [],
    financeInstitutionName = '',
    dataProvideAgreeSeq = 0,
    moveAgreePage = false,
  } = essentialMallData;

  // 안내문구 생성
  const makeDescription = () => {
    const isWaitOrFinish = essentialMallList.every(
      item =>
        item.mallInterlockStatus === 'WAIT' ||
        item.mallInterlockStatus === 'FINISH'
    );

    if (isWaitOrFinish) {
      if (moveAgreePage) {
        return (
          <span>
            {`${financeInstitutionName} 대출 진행을 위해 `}
            <strong>[데이터 제공 동의]</strong> 버튼을 눌러 대출 신청을 완료해
            주세요.
          </span>
        );
      } else {
        return (
          <span>
            {`${financeInstitutionName} 대출 진행을 위해 `}
            <strong>[연동상태 최신화]</strong> 버튼을 눌러 연동결과를 확인해
            주세요.
          </span>
        );
      }
    } else {
      return `${financeInstitutionName} 대출 진행을 위해 필수 판매몰 연동 상태를 확인해 주세요.`;
    }
  };

  // essentialMallData 데이터 가공
  const formatStatusData = () => {
    const makeMallNameList = name =>
      essentialMallList
        ?.filter(item => item.mallInterlockStatus === name)
        .map(item => item.mallName);

    return {
      FAIL: makeMallNameList('FAIL'),
      NOT_LINKED: makeMallNameList('NOT_LINKED'),
      STOP: makeMallNameList('STOP'),
      UNAVAILABLE: makeMallNameList('UNAVAILABLE'),
      WAIT: makeMallNameList('WAIT'),
      FINISH: makeMallNameList('FINISH'),
    };
  };

  // 연동 상태별 판매몰 안내 생성
  const makeStatusContents = () => {
    const statusData = formatStatusData();

    return Object.keys(statusData).map((key, index) => {
      if (statusData[key]?.length > 0) {
        return (
          <dl key={`mall_linkage_status_${index}`}>
            <dt className={key}>{LINKAGE_STATUS_NAME[key]}</dt>
            <dd>{statusData[key].join(', ')}</dd>
          </dl>
        );
      }
    });
  };

  // 데이터 제공 동의 버튼 클릭
  const onClickDataAgreeBtn = () => {
    localStorage.setItem(KEY_DATAPROVIDEAGREESEQ, dataProvideAgreeSeq);
    navigate(ROUTE_PATH.deepLink.agree);
  };

  return (
    <SectionWrapper className="noticeSection">
      <p className="title">
        <img alt="사이렌 표시" src="/images/icons/siren.png" />
        <strong>먼저 확인해 주세요!</strong>
      </p>
      <p className="description">{makeDescription()}</p>
      <div>{makeStatusContents()}</div>
      {moveAgreePage && (
        <button type="button" onClick={onClickDataAgreeBtn}>
          데이터 제공 동의
        </button>
      )}
    </SectionWrapper>
  );
};

export default NoticeSection;
